import { useCallback } from 'react';
import { useStationsOperations } from 'entities/stations';
import {
  useGetStationByCode,
  useOperations,
  useStations,
  useAllStations
} from 'store/features/stations';
import {useCheckIsExistFavouriteBrandByCode } from 'entities/brands';

import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

import { STATIONS_AMPLITUDE_EVENTS } from 'entities/stations';
import { EMPTY_ARRAY } from 'common/constants';

import { IStation } from 'dataSources/Typicode/stations/types';

export const useDeleteFavouriteStation = () => {
  const stations = useStations() || EMPTY_ARRAY;
  const allStations = useAllStations() || EMPTY_ARRAY;
  const {
    getFavouriteStations,
    deleteFavouriteStations
  } = useStationsOperations();
  const getStationByCode = useGetStationByCode();
  const { updateStations, updateAllStations } = useOperations();

  const checkIsExistFavouriteBrandByCode = useCheckIsExistFavouriteBrandByCode();

  const changeStations = useCallback((stations?: IStation[], updatedStation?: IStation) => {
    if (!stations || !updatedStation) {
      return stations || EMPTY_ARRAY;
    }

    const copiedStations = [...stations];
    const index = copiedStations.findIndex(item => item.code === updatedStation.code);
    if (index !== undefined) {
      copiedStations[index] = updatedStation;
    }
    return copiedStations;
  }, []);

  const deleteFavouriteStation = useCallback(async (stationCode: string) => {
    await deleteFavouriteStations([stationCode]);
    getFavouriteStations();
    const station = getStationByCode(stationCode);

    if (station && !checkIsExistFavouriteBrandByCode(station.brandCode)) {
      const updatedStation = { ...station, favourite: false };

      updateStations(changeStations(stations, updatedStation));
      updateAllStations(changeStations(allStations, updatedStation));
    }

    logAmplitudeEvent(STATIONS_AMPLITUDE_EVENTS.deleteFavouriteBrand, { extra: { stationCode } });
  }, [
    deleteFavouriteStations,
    getFavouriteStations,
    getStationByCode,
    updateStations,
    checkIsExistFavouriteBrandByCode,
    stations,
    allStations,
    changeStations,
    updateAllStations
  ]);

  return deleteFavouriteStation;
};
